import React, { useState } from "react";
import { GeoJSON } from "react-leaflet";
import GetCount from "../components/GetCount";

function ColourCode(count, countBorders) {
  const colourArray = ["#F1EEF6", "#BDC9E1", "#74A9CF", "#2B8CBE", "#045A8D"];
  let colourCode;

  for (let i = 0; i < countBorders.length; i++) {
    if (count <= countBorders[i]) {
      colourCode = colourArray[i];
      break;
    } else if (count >= countBorders[4]) {
      colourCode = colourArray[4];
    }
  }

  return colourCode;
}

function Geocomp(props) {
  const chosenCountry = props.giveSelectedCountry;
  const dataCount = props.dataCount;
  const countBorders = props.countBorders;

  // Set the general opacity and colour of the Polygons created in the map
  const inFillOpacity = 0.5;
  const borderOpacity = 1;
  const borderColor = "black";
  const borderWeight = 0.2;

  // Turn JSON file in Array which React can recognize for the Map-function
  const returnedArray =
    props.dataGeoJSON !== null
      ? Array.from(props.dataGeoJSON.features)
      : [];

  // Used to determine wether or not the corresponding GeoJSON has been clicked
  const [countryGeo, setCountryGeo] = useState("none");

  // Turn every country in a GeoJSON polygon
  const arrayGeoComps = returnedArray.map((element) => {
    if (dataCount !== null) {
      let nameCountry = element.properties.admin;
      let abbreviation = element.properties.adm0_a3;
      let geometryData = element.geometry;
      const countMeasures = GetCount(nameCountry, dataCount);
      const colourCode = ColourCode(countMeasures, countBorders);

      // Action needed when a country is being clicked
      function clickCountry() {
        setCountryGeo(nameCountry);
        // sends data back to parent
        props.selectedCountry(nameCountry);
      }

      let textMeasures = countMeasures > 1 ? " measures" : " measure";

      if (countMeasures > 0) {
        // Return per country a GeoJSON Polygon comp
        return (
          <GeoJSON
            key={nameCountry}
            data={{
              type: "Feature",
              id: abbreviation,
              properties: { name: nameCountry },
              geometry: geometryData,
            }}
            style={{
              fillColor: colourCode,
              color: borderColor,
              weight:
                countryGeo !== nameCountry || chosenCountry !== nameCountry
                  ? borderWeight
                  : borderWeight * 10,
              fillOpacity: inFillOpacity,
              opacity: borderOpacity,
            }}
            onEachFeature={function onEachFeature(feature, layer) {
              layer.bindTooltip(
                nameCountry + " " + countMeasures + textMeasures,
                {
                  direction: "left",
                  sticky: true,
                }
              );
              layer.on({
                click: clickCountry,
              });
            }}
          />
        );
      }
    }
  });

  // Return the array of all the countries polygons
  return <div>{arrayGeoComps}</div>;
}

export default Geocomp;
